export enum PessoaDocumentoTipo {
  CC = 'CC',
  CEI = 'CEI',
  CI = 'CI',
  CN = 'CN',
  CNH = 'CNH',
  CNPJ = 'CNPJ',
  CP = 'CP',
  CPF = 'CPF',
  CT = 'CT',
  IF = 'IF',
  NB = 'NB',
  NIT = 'NIT',
  OAB = 'OAB',
  OUTROS = 'OUTROS',
  PAS = 'PAS',
  PIS_PASEP = 'PIS_PASEP',
  RGE = 'RGE',
  RIC = 'RIC',
  RJC = 'RJC',
  RJI = 'RJI',
  TE = 'TE'
}
